import { useEffect } from "react"
import { useApplication } from "../../../store/application/hooks"
import { Models } from "../../viewer/renderer.api"
import { useTranslation } from "react-i18next"
import { useHistory } from "react-router"
import { useFloor } from "../../../store/floor/hooks"
import { renderer } from "../../viewer/Renderer"
import { useRoutes } from "../../../store/routes/hooks"
import { FloorInsulationTypes } from "@iko-design-center/shared"

export function useFloorHeating() {
  const { currentModel, directLink, setDirectLink } = useApplication()
  const { Routes } = useRoutes() as any
  const { t, i18n } = useTranslation() as any
  const country = i18n.language.split("_")[1]
  const history = useHistory()

  const {
    configurationState,
    setFloorHeatingType: setFloorHeatingTypeState,
    setFloorInsulationType: setFloorInsulationTypeState,
  } = useFloor()

  const floorHeatingType = configurationState.floorHeating.type
  const nextButtonDisabled = !floorHeatingType

  useEffect(() => {
    if (renderer && currentModel === Models.DOLLHOUSE && directLink) {
      setDirectLink(false)
      renderer.displayModel(Models.FLOOR).then(() => renderer.hideMarkers())
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  function handleNextButtonClick() {
    if (country !== "de") {
      history.push(Routes.FLOOR_2_FLOOR_INSULATION)
    } else {
      setFloorInsulationTypeState(FloorInsulationTypes.ENERTHERM_ALU_FB)
      renderer.displayFloorInsulationType(FloorInsulationTypes.ENERTHERM_ALU_FB)
      history.push(Routes.FLOOR_3_FLOOR_SCREED)
    }
  }

  function setFloorHeatingType(type: any) {
    setFloorHeatingTypeState(type)
    renderer.displayFloorHeatingType(type)
  }

  return {
    t,
    floorHeatingType,
    setFloorHeatingType,
    handleNextButtonClick,
    nextButtonDisabled,
  }
}
